/* global edmunds_api */
function EdmundsAPI() {
	var self = this;
  self.adminAjax = edmunds_api.ajax_url;
  self.nonce = edmunds_api.nonce;

	self.helpers = {};

  self._ajax = function(data) {
    return jQuery.get(self.adminAjax, data);
  }

	self._option = function(options, key, defaultValue) {
		if ( typeof options[key] !== 'undefined' ) {
			return encodeURIComponent(options[key]);
		}

		return defaultValue;
	};

	self.helpers.getStateFromZip = function(zip, success, failure) {
		if ( zip.length != 5 ) {
			failure('invalid_zip');
			return false;
		}

		jQuery.get('https://maps.googleapis.com/maps/api/geocode/json?address='+zip).done(function(data) {
			var addressComponents = data.results[0].address_components;
			var zipCode = false;
			var state = false;
			for ( var index in addressComponents ) {
				var component = addressComponents[index];
				if ( component.types[0] == 'postal_code' ) {
					zipCode = component.short_name;
				}

				if ( component.types[0] == 'administrative_area_level_1' ) {
					state = component.short_name;
				}
			}

			if ( zipCode && state ) {
				success(zipCode, state);
			} else {
				failure('invalid_zip');
			}
		});
	}

	self.priceCostToOwn = function(options, success, failure) {
		var condition = self._option(options, 'condition');
		var style = self._option(options, 'style');
		var zip = self._option(options, 'zip');

		if ( ! condition ) {
			if ( failure ) {
				failure();
			}

			return;
		}

    var requestData = {
      action: 'price_cost_to_own',
      nonce: self.nonce,
      requestKeys: {
        style: style,
        condition: condition,
        zip: zip
      }
    };
    var promise = self._ajax(requestData);

		promise.done(function(data) {
			if ( success ) {
        var data = JSON.parse(data);
				success(data.value);
			}
		});

		promise.fail(function() {
			if ( failure ) {
				failure();
			}
		});
	};

	self.totalCashPrice = function(options, success, failure) {
		var condition = self._option(options, 'condition');
		var style = self._option(options, 'style');
		var zip = self._option(options, 'zip');

		if ( ! condition ) {
			if ( failure ) {
				failure();
			}

			return;
		}

    var requestData = {
      action: 'total_cash_price',
      nonce: self.nonce,
      requestKeys: {
        style: style,
        condition: condition,
        zip: zip
      }
    };
		var promise = self._ajax(requestData);

		promise.done(function(data) {
			if ( success ) {
        var data = JSON.parse(data);
				success(data.value);
			}
		});

		promise.fail(function() {
			if ( failure ) {
				failure();
			}
		});
	};

	function translateDetailsToRows(data) {
		var table = [];
		
		var labels = {
			"insurance": "Insurance",
			"maintenance": "Maintenance",
			"repairs": "Repairs",
			"taxandfees": "Taxes & Fees",
			"financing": "Financing",
			"depreciation": "Depreciation",
			"fuel": "Fuel",
			"taxcredit": "Tax Credit",
		};
		
		for (var categoryName in data) {
			var category = data[categoryName];

			var row = [];

			if ( typeof category == 'object' ) {
				row = category.values;
				row.push(category.total);
			} else {
				row = [category, category, category, category, category, category];
			}

			row.unshift(labels[categoryName]);
			
			table.push(row);
		}
		
		var bottomRow = ["Edmunds True Cost to Own&reg;"];
		for(var i = 1; i <= 6; i++) {
			var total = 0;
			for(var rowIndex in table) {
				total += table[rowIndex][i];
			}

			bottomRow.push(total);
		}
		
		table.push(bottomRow);
		
		return table;
	}

	self.totalCostToOwnDetails = function(options, success, failure) {
		var condition = self._option(options, 'condition');
		var style = self._option(options, 'style');
		var zip = self._option(options, 'zip');
		var state = self._option(options, 'state');

		if ( ! condition ) {
			if ( failure ) {
				failure();
			}

			return;
		}

    var requestData = {
      action: 'total_cost_to_own',
      nonce: self.nonce,
      requestKeys: {
        style: style,
        condition: condition,
        zip: zip,
        state: state
      }
    };
		var promise = self._ajax(requestData);

		promise.done(function(data) {
      var data = JSON.parse(data);
			var details = jQuery.map(data, function(element, index) {
				return {
					label: index,
					value: element.total
				};
			});
			
			if ( success ) {
				success(details, translateDetailsToRows(data));
			}
		});

		promise.fail(function() {
			if ( failure ) {
				failure();
			}
		});
	};
}
